import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import styled from "styled-components";
import { useCoursesContext } from '../../context/courses/courses_context';
import StarRating from '../../components/course/StarRating';
import {MdInfo} from "react-icons/md";
import {TbWorld} from "react-icons/tb";
import {FaShoppingCart} from "react-icons/fa";
import {RiClosedCaptioningFill} from "react-icons/ri";
import {BiCheck} from "react-icons/bi";
import {Link} from "react-router-dom";
import Navbar from '../../components/course/Navbar';
import Sidebar from '../../components/course/Sidebar';
import Courses from '../courses/Courses';
import CourseClasses from './CourseClasses';
import { useCartContext } from '../../context/cart/cart_context';
//import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { BiLock } from 'react-icons/bi';
import ClassCard from '../../components/course/ClassCard';

const SingleCoursePage = () => {
  const {id} = useParams();
  const {fetchSingleCourse, single_course} = useCoursesContext();
  const {addToCart} = useCartContext();
  const [showClasses, setShowClasses] = useState(false);

  const [expandedItems, setExpandedItems] = useState({});

   const documents=[
    { uri: ('https://docs.google.com/document/d/1Wn5eX1-Urp3cbCU1jElG3L4TslN4s6tm/edit'), fileName: 'Document 1'},
    { uri: ('https://docs.google.com/document/d/1AOuLPbMN_CzFmYa9Ki4YHEKCg_EkEIDM/edit?usp=sharing&ouid=110038922840933689817&rtpof=true&sd=true'), fileType: 'docx', fileName: 'Document 2'},
    { uri: ('https://docs.google.com/document/d/1uVlMC3K0TP3EnO6OMjLDPDX0yk0vCGPT/edit?usp=drive_link&ouid=110038922840933689817&rtpof=true&sd=true'), fileType: 'docx', fileName: 'Document 3'},
  ]

  // Toggle the expansion state of a content item when clicked
  const handleContentItemClick = (idx) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [idx]: !prevState[idx],
    }));
  };


  useEffect(() => {
    fetchSingleCourse(id);
  }, []);

  const {id: courseID, category, image, course_name, description, rating_count, rating_star, students, creator, updated_date, lang, actual_price, discounted_price, what_you_will_learn: learnItems, content, course_files} = single_course;

  return (
    <>
    
    <Navbar />
    <Sidebar />
    <SingleCourseWrapper>
      <div className='course-intro mx-auto grid'>
        <div className='course-img'>
          <img src = {image} alt = {course_name} />
        </div>
        <div className='course-details'>
          <div className='course-category bg-white text-dark text-capitalize fw-6 fs-12 d-inline-block'>{category}</div>
          <div className='course-head'>
            <h5>{course_name}</h5>
          </div>
          <div className='course-body'>
            <p className='course-para fs-18'>{description}</p>
            <div className='course-rating flex'>
              <span className='rating-star-val fw-8 fs-16'>{rating_star}</span>
              <StarRating rating_star={rating_star} />
              <span className='rating-count fw-5 fs-14'>({rating_count})</span>
              <span className='students-count fs-14'>{students}</span>
            </div>

            <ul className='course-info'>
              <li>
                <span className='fs-14'>Created by <span className='fw-6 opacity-08'>{creator}</span></span>
              </li>
              <li className='flex'>
                <span><MdInfo /></span>
                <span className='fs-14 course-info-txt fw-5'>Course Duration 30 days</span>
              </li>
              <li className='flex'>
                <span><TbWorld /></span>
                <span className='fs-14 course-info-txt fw-5'>{lang}</span>
              </li>
              <li className='flex'>
                <span><RiClosedCaptioningFill /></span>
                <span className='fs-14 course-info-txt fw-5'>{lang} [Auto]</span>
              </li>
            </ul>
          </div>

          <div className='course-foot'>
            <div className='course-price'>
              <span className='new-price fs-26 fw-8'>${discounted_price}</span>
              <span className='old-price fs-26 fw-6'>${actual_price}</span>
            </div>
          </div>

          <div className='course-btn'>
            {/*<Link to = "/cart" className='add-to-cart-btn d-inline-block fw-7 bg-purple' onClick={() => addToCart(courseID, image, course_name, creator, discounted_price, category)}>
              View Available Classes
  </Link> */}
               <button
                    className='add-to-cart-btn d-inline-block fw-7 bg-purple'
                    onClick={() => setShowClasses(!showClasses)}
                >
                {showClasses ? "Hide Available Classes" : "View Available Classes"}
                </button>  
          </div>
        </div>
      </div>

      <div className='course-full bg-white text-dark'>

      {showClasses && (
        <div className='available-classes'>
          {/* Replace this with the code to render the available classes */}
          {/* For example: */}
          <CourseClasses courseid={courseID}/>
        </div>
      )}

        <div className='course-learn mx-auto'>
          <div className='course-sc-title'>What you'll learn</div>
          <ul className='course-learn-list grid'>
            {
              learnItems && learnItems.map((learnItem, idx) => {
                return (
                  <li key = {idx}>
                    <span><BiCheck /></span>
                    <span className='fs-14 fw-5 opacity-09'>{learnItem}</span>
                  </li>
                )
              })
            }
          </ul>
          </div>

        <div className='course-content mx-auto'>
        <div className='course-sc-title'>Course content</div>
        <ul className='course-content-list'>
          {content &&
            content.map((contentItem, idx) => (
              <li key={idx} onClick={() => handleContentItemClick(idx)} className={`content-item ${expandedItems[idx] ? 'expanded' : ''}`}>
                <span>{contentItem}</span>
                {idx >= 3 ? (
                  <BiLock className='lock-icon' />
                ) : (
                  expandedItems[idx] ? <BiCheck className='check-icon' /> : <MdInfo className='info-icon' />
                )}
                {/* Render file links for the first three content items */}
                {idx < 3 && (
                  <ul className='file-list'>
                    {course_files.map((file, fileIdx) => (
                      <li key={fileIdx}>
                        <a href={file.file_url} target='_blank' rel='noopener noreferrer'>
                          {file.file_name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
        </ul>
        {expandedItems[0] && (
          <div className='document-viewer'>
         {/*}   <DocViewer
                documents={documents}
                initialActiveDocument={documents[1]}
                pluginRenderers={DocViewerRenderers}
        />*/}
  
          </div>
        )}
      </div>
      </div>

      </SingleCourseWrapper>
      
   
    </>
  )
}

const SingleCourseWrapper = styled.div`
  background: var(--clr-dark);
  color: var(--clr-white);

  .course-intro{
    padding: 40px 16px;
    max-width: 992px;

    .course-details{
      padding-top: 20px;
    }

    .course-category{
      padding: 0px 8px;
      border-radius: 6px;
    }

    .course-head{
      font-size: 38px;
      line-height: 1.2;
      padding: 12px 0 0 0;
    }
    .course-para{
      padding: 12px 0;
    }
    .rating-star-val{
      margin-right: 7px;
      padding-bottom: 5px;
      color: var(--clr-orange);
    }
    .students-count{
      margin-left: 8px;
    }
    .rating-count{
      margin-left: 6px;
      color: #d097f6;
    }
    .course-info{
      li{
        margin-bottom: 2px;
        &:nth-child(2){
          margin-top: 10px;
        }
      }
      .course-info-txt{
        text-transform: capitalize;
        margin-left: 8px;
        margin-bottom: 4px;
      }
    }
    .course-price{
      margin-top: 12px;
      .old-price{
        color: #eceb98;
        text-decoration: line-through;
        margin-left: 10px;
      }
    }
    .course-btn{
      margin-top: 16px;
      .add-to-cart-btn{
        padding: 12px 28px;
        span{
          margin-left: 12px;
        }
      }
    }

    @media screen and (min-width: 880px){
      grid-template-columns: repeat(2, 1fr);
      column-gap: 40px;
      .course-details{
        padding-top: 0;
      }
      .course-img{
        order: 2;
      }
    }

    @media screen and (min-width: 1400px){
      grid-template-columns: 60% 40%;
    }
  }

  .course-full{
    padding: 40px 16px;
    .course-sc-title{
      font-size: 22px;
      font-weight: 700;
      margin: 12px 0;
    }
    .course-learn{
      max-width: 992px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-learn-list{
        li{
          margin: 5px 0;
          display: flex;
          span{
            &:nth-child(1){
              opacity: 0.95;
              margin-right: 12px;
            }
          }
        }

        @media screen and (min-width: 992px){
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }

    .course-content{
      max-width: 992px;
      margin-top: 30px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding: 12px 28px 22px 28px;

      .course-content-list{
        li{
          background-color: #f7f9fa;
          padding: 12px 18px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          margin-bottom: 10px;
          font-weight: 800;
          font-size: 15px;
        }
      }
    }
  }

`;

export default SingleCoursePage